import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1872af58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-center md:justify-between flex-col sm:flex-row items-center mt-5" }
const _hoisted_2 = { class: "intro-y text-lg font-medium m-auto md:mr-auto md:ml-0" }
const _hoisted_3 = { class: "intro-y grid grid-cols-12 gap-3 sm:gap-2 mt-5" }
const _hoisted_4 = { class: "intro-y col-span-12 md:col-span-6 xxl:col-span-4" }
const _hoisted_5 = { class: "flex flex-row box items-center justify-between pt-4 sm:pt-5 px-3 sm:px-5 pb-4 border-b-2 border-gray-200 dark:border-dark-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "intro-y text-lg font-medium m-auto md:mr-auto md:ml-0" }, " Data User ", -1))
const _hoisted_7 = {
  id: "dtUser",
  class: "overflow-x-auto box"
}
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { class: "border-b whitespace-nowrap font-bold px-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-b whitespace-nowrap w-8 px-0" }, ":", -1))
const _hoisted_11 = { class: "border-b whitespace-nowrap px-0" }
const _hoisted_12 = { class: "intro-y col-span-12 md:col-span-6 xxl:col-span-4" }
const _hoisted_13 = { class: "flex flex-row box items-center justify-between pt-4 sm:pt-5 px-3 sm:px-5 pb-4 border-b-2 border-gray-200 dark:border-dark-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "intro-y text-lg font-medium m-auto md:mr-auto md:ml-0" }, " Keterangan Ujian ", -1))
const _hoisted_15 = {
  id: "ketUji",
  class: "overflow-x-auto box"
}
const _hoisted_16 = { class: "table" }
const _hoisted_17 = { class: "border-b font-bold px-0" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-b w-8 px-0" }, ":", -1))
const _hoisted_19 = { class: "border-b whitespace-nowrap px-0" }
const _hoisted_20 = { class: "flex flex-row box items-center justify-between pt-4 sm:pt-5 px-3 sm:px-5 pb-4 border-b-2 border-gray-200 dark:border-dark-5" }
const _hoisted_21 = { class: "intro-y text-lg font-medium m-auto md:mr-auto md:ml-0" }
const _hoisted_22 = ["id", "onClick"]
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "table" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-b font-bold px-0" }, "Poin", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-b w-8 px-0" }, ":", -1))
const _hoisted_27 = { class: "border-b whitespace-nowrap px-0" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-b font-bold px-0" }, "Passing Grade", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-b w-8 px-0" }, ":", -1))
const _hoisted_30 = { class: "border-b whitespace-nowrap px-0" }
const _hoisted_31 = { class: "border-b font-bold px-0" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "border-b w-8 px-0" }, ":", -1))
const _hoisted_33 = { class: "border-b whitespace-nowrap px-0" }
const _hoisted_34 = { class: "px-5 py-3 font-bold" }
const _hoisted_35 = { class: "intro-y grid grid-cols-12 gap-3 sm:gap-2 mt-3 md:mt2" }
const _hoisted_36 = { class: "intro-y col-span-12 box px-3 sm:px-5 pb-5" }
const _hoisted_37 = { class: "flex flex-row items-center justify-between py-5 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "intro-y text-lg font-medium m-0 md:mr-auto md:ml-0" }, " Pembahasan Soal ", -1))
const _hoisted_39 = { class: "grid grid-cols-12 w-24 sm:w-32 button p-0 items-center justify-center text-white cursor-pointer" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-block col-span-5 sm:col-span-4 py-3 px-1 bg-blue-800 text-center rounded rounded-r-none" }, "NO", -1))
const _hoisted_41 = { class: "inline-block col-span-7 sm:col-span-8 p-3 bg-blue-600 text-center rounded rounded-l-none" }
const _hoisted_42 = { class: "pt-3 pb-2" }
const _hoisted_43 = { class: "text-base font-medium mt-1 mb-1 uppercase" }
const _hoisted_44 = ["src"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["opt"]
const _hoisted_47 = { class: "inline-block px-2 py-2 w-8 rounded rounded-r-none text-center border border-gray-500 dark:border-gray-600" }
const _hoisted_48 = { class: "inline-block pl-2 sm:pl-3 pr-2 py-2 w-full rounded rounded-l-none text-left border border-gray-500 dark:border-gray-600" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { class: "items-center justify-center justify-items-center pt-3 pb-5 border-t-2 border-green-500 dark:border-green-800" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "intro-y text-lg font-medium m-auto md:mr-auto md:ml-0" }, " Pembahasan ", -1))
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { class: "items-center justify-center justify-items-center pt-3 pb-5 border-t-2 border-green-500 dark:border-green-800" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "intro-y text-lg font-medium m-auto md:mr-auto md:ml-0" }, " Image Pembahasan ", -1))
const _hoisted_57 = ["src"]
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "items-center justify-center justify-items-center pt-3 pb-5 border-t-2 border-green-500 dark:border-green-800" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "intro-y text-lg font-medium m-auto md:mr-auto md:ml-0" }, " Kunci Jawaban ", -1))
const _hoisted_61 = ["opt"]
const _hoisted_62 = { class: "inline-block px-2 py-2 w-8 rounded rounded-r-none text-center border border-gray-500 dark:border-gray-600" }
const _hoisted_63 = { class: "inline-block pl-2 sm:pl-3 pr-2 py-2 w-full rounded rounded-l-none text-left border border-gray-500 dark:border-gray-600" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "font-bold text-primary" }
const _hoisted_66 = { class: "flex flex-row items-center justify-center justify-items-center pt-5 border-t border-gray-200 dark:border-dark-5" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, "Back", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:block" }, "Next", -1))
const _hoisted_69 = { class: "intro-y col-span-12 box p-2" }
const _hoisted_70 = { class: "intro-y col-span-12 flex flex-row justify-between border-b border-gray-200 dark:border-dark-5 pt-2 pb-3" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "intro-y text-lg font-medium w-full" }, "Navigasi Soal", -1))
const _hoisted_72 = { class: "w-auto overflow-auto scrollbar-nav-soal mb-3" }
const _hoisted_73 = {
  id: "nsRn",
  class: "flex flex-row"
}
const _hoisted_74 = ["onClick"]
const _hoisted_75 = {
  key: 0,
  class: "inline-block absolute px-1 top-0 right-0 bg-primary rounded-bl-lg rounded-tr-sm",
  style: {"font-size":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, " Hasil Tryout \"" + _toDisplayString(_ctx.dataTH.title) + "\" ", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("a", {
            id: "vDtUser",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.rnTop('vDtUser', 'dtUser'))),
            href: "javascript:;",
            class: "font-bold cursor-pointer transform rotate-180"
          }, [
            _createVNode(_component_ChevronDownIcon, { class: "w-6 h-6 mr-0" })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTH.hasil, (du, idx) => {
                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(du.label), 1),
                  _hoisted_10,
                  _createElementVNode("td", _hoisted_11, _toDisplayString(du.value), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("a", {
            id: "vKetUji",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rnTop('vKetUji', 'ketUji'))),
            href: "javascript:;",
            class: "font-bold cursor-pointer transform rotate-180"
          }, [
            _createVNode(_component_ChevronDownIcon, { class: "w-6 h-6 mr-0" })
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTH.keterangan, (du, idx) => {
                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                  _createElementVNode("td", _hoisted_17, _toDisplayString(du.label), 1),
                  _hoisted_18,
                  _createElementVNode("td", _hoisted_19, _toDisplayString(du.value), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTH.analisa, (als, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "intro-y col-span-12 md:col-span-6 xxl:col-span-4"
        }, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h3", _hoisted_21, _toDisplayString(als.label), 1),
            _createElementVNode("a", {
              id: 'vAls'+idx,
              onClick: ($event: any) => (_ctx.rnTop('vAls'+idx, 'ketAls'+idx)),
              href: "javascript:;",
              class: "font-bold cursor-pointer"
            }, [
              _createVNode(_component_ChevronDownIcon, { class: "w-6 h-6 mr-0" })
            ], 8, _hoisted_22)
          ]),
          _createElementVNode("div", {
            id: 'ketAls'+idx,
            class: "overflow-x-auto box hidden"
          }, [
            _createElementVNode("table", _hoisted_24, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("td", _hoisted_27, _toDisplayString(als.poin), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_28,
                  _hoisted_29,
                  _createElementVNode("td", _hoisted_30, _toDisplayString(als.passingGrade), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(als.items, (du, idx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                    _createElementVNode("td", _hoisted_31, _toDisplayString(du.label), 1),
                    _hoisted_32,
                    _createElementVNode("td", _hoisted_33, _toDisplayString(du.percent), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("p", _hoisted_34, "Notes : " + _toDisplayString(als.notes), 1)
          ], 8, _hoisted_23)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.cis + 1), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.cs.kategori), 1),
          (_ctx.cs.questionImg)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.cs.questionImg,
                class: "m-2",
                alt: "Image Soal"
              }, null, 8, _hoisted_44))
            : _createCommentVNode("", true),
          _createElementVNode("p", {
            class: "border-b border-gray-500 dark:border-gray-600 p-2 mb-2 bg-gray-200 dark:bg-dark-1",
            innerHTML: _ctx.cs.question
          }, null, 8, _hoisted_45),
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cs.options, (opt, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                opt: 'chs-' + _ctx.cs.nomor + '-' + idx,
                class: _normalizeClass([
                'flex flex-row justify-items-center my-3 md:my2 button p-0 list-chs',
                _ctx.cs.answerUser === opt.option ? 'active' : '',
                opt.text ? '' : 'hidden',
              ])
              }, [
                _createElementVNode("span", _hoisted_47, _toDisplayString(opt.option), 1),
                _createElementVNode("span", _hoisted_48, [
                  (opt.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: opt.image,
                        alt: "Image Opsi Soal"
                      }, null, 8, _hoisted_49))
                    : _createCommentVNode("", true),
                  (opt.image)
                    ? (_openBlock(), _createElementBlock("br", _hoisted_50))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: opt.text
                  }, null, 8, _hoisted_51)
                ])
              ], 10, _hoisted_46))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("p", {
            class: "border-b border-gray-500 dark:border-gray-600 p-2 bg-gray-200 dark:bg-dark-1",
            innerHTML: _ctx.trimText(_ctx.cs.pembahasan)
          }, null, 8, _hoisted_54)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          (_ctx.cs.pembahasanImg)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.cs.pembahasanImg,
                class: "m-2",
                alt: "Image Soal"
              }, null, 8, _hoisted_57))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "border-b border-gray-500 dark:border-gray-600 p-2 bg-gray-200 dark:bg-dark-1",
                innerHTML: _ctx.trimText(_ctx.cs.pembahasanImg)
              }, null, 8, _hoisted_58))
        ]),
        _createElementVNode("div", _hoisted_59, [
          _hoisted_60,
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cs.options, (opt, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                opt: 'chs-' + _ctx.cs.nomor + '-' + idx,
                class: _normalizeClass([
                'flex flex-row justify-items-center my-3 md:my2 button p-0 list-chs',
                _ctx.cs.answer === opt.option ? 'active' : 'hidden',
              ])
              }, [
                _createElementVNode("span", _hoisted_62, _toDisplayString(opt.option), 1),
                _createElementVNode("span", _hoisted_63, [
                  _createElementVNode("div", {
                    innerHTML: opt.text
                  }, null, 8, _hoisted_64)
                ])
              ], 10, _hoisted_61))
            }), 128))
          ]),
          _createElementVNode("p", _hoisted_65, " Point Anda " + _toDisplayString(_ctx.trimText(_ctx.cs.poinUser)), 1)
        ]),
        _createElementVNode("div", _hoisted_66, [
          (_ctx.cis !== 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button w-auto h-11 mr-2 md:mr-5 pl-1 md:pr-5 flex items-center justify-center bg-theme-1 text-white",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSoalCis('back')))
              }, [
                _createVNode(_component_ChevronLeftIcon, { class: "w-6 h-6 ml-1 mr-0 sm:mr-2 font-bold" }),
                _hoisted_67
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "button w-auto h-11 ml-2 md:ml-5 pl-3 md:pl-5 md:pr-1 pr-2 sm:pr-1 flex items-center justify-center bg-theme-1 text-white flex-row-reverse",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSoalCis('next')))
          }, [
            _createVNode(_component_ChevronRightIcon, { class: "w-6 h-6 ml-0 sm:ml-2 font-bold mr-auto" }),
            _hoisted_68
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("a", {
            id: "cvRn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rn())),
            href: "javascript:;",
            class: "font-bold cursor-pointer"
          }, [
            _createVNode(_component_ChevronDownIcon, { class: "w-6 h-6 mr-0" })
          ])
        ]),
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("ol", _hoisted_73, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSoal, (soal, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                class: _normalizeClass([
                'my-2 px-2 list-ns',
                soal.answerUser === _ctx.trimText(soal.answer) ? 'yakin' : '',
                soal.answerUser !== _ctx.trimText(soal.answer) ? 'salah' : '',
                idx === _ctx.cis ? 'active' : '',
              ])
              }, [
                _createElementVNode("button", {
                  class: "intro-y w-16 h-10 rounded button bg-gray-200 dark:bg-dark-1 text-gray-600 px-1",
                  onClick: ($event: any) => (_ctx.changeSoal(soal, idx))
                }, [
                  _createTextVNode(_toDisplayString(idx + 1) + " - " + _toDisplayString(soal.answerUser === undefined ? "" : soal.answerUser) + " ", 1),
                  (idx === _ctx.cis)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_75, "N"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_74)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}